import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Charity } from '../../types/charity/charity';
import { persistReducer } from 'redux-persist';
import localStorage from 'redux-persist/lib/storage';
import { CustomField } from '../../types/custom-fields/custom-field';
import { getSupportedBrowserLanguage } from '../../utils/translations/local-language';
import { SupportedLanguage } from '../../utils/translations/supported-languages';

interface SessionState {
  username: string | undefined
  currentCharityId: string | undefined
  charity: Charity | undefined // TODO: To be retrieved
  activeFilters: Record<string, any> | null
  customFields: CustomField[] | undefined
  language: SupportedLanguage
}

const initialState: SessionState = {
  username: undefined,
  currentCharityId: undefined,
  charity: undefined,
  activeFilters: {},
  customFields: undefined,
  language: getSupportedBrowserLanguage() ?? 'it'
};

const sessionSlice = createSlice({
  name: 'session',
  initialState: {
    ...initialState,
  },
  reducers: {
    setUser(state, action: PayloadAction<string>) {
      state.username = action.payload;
    },
    setCurrentCharityId(state, action: PayloadAction<string>) {
      state.currentCharityId = action.payload;
    },
    setCharity(state, action: PayloadAction<Charity | undefined>) {
      state.charity = action.payload;
    },
    setCustomFields(state, action: PayloadAction<CustomField[]>) {
      state.customFields = action.payload;
    },
    logout(state) {
      state.username = undefined;
      state.currentCharityId = undefined;
      state.charity = undefined;
    },
    updateFilters(state, action: PayloadAction<Record<string, any>>) {
      state.activeFilters = { ...state.activeFilters, ...action.payload }
    },
    removeFilter(state, action: PayloadAction<string>) {
      if (state.activeFilters) delete state.activeFilters[action.payload]
    },
    removeAllFilters(state) {
      state.activeFilters = null
    },
    setLanguage(state, action: PayloadAction<SupportedLanguage>) {
      state.language = action.payload
    }
  },
})

export const { setUser, setCurrentCharityId, setCharity, setCustomFields, logout, updateFilters, removeFilter, removeAllFilters, setLanguage } = sessionSlice.actions;

export default persistReducer({ key: sessionSlice.name, storage: localStorage, whitelist: ['username', 'currentCharityId', 'language'] }, sessionSlice.reducer);
